const isPlainObj = (value)=>{
    if (!value) return false;
    const proto = Object.getPrototypeOf(value);
    return !!proto && !Object.getPrototypeOf(proto);
};
/**
 * Merge default props with provided props, handling nested objects
 *
 * @param props - The props provided by the user
 * @param defaultProps - The default props to merge with
 * @returns The merged props
 */ const mergeDefaultProps = (props = {}, defaultProps)=>{
    const newProps = {
        ...props
    };
    // Resolve default props, code borrowed from React source.
    // https://github.com/facebook/react/blob/15a8f031838a553e41c0b66eb1bcf1da8448104d/packages/react/src/ReactElement.js#L221
    for(const propName in defaultProps){
        if (props[propName] === undefined) {
            newProps[propName] = defaultProps[propName];
        } else if (isPlainObj(props[propName]) && isPlainObj(defaultProps[propName])) {
            newProps[propName] = mergeDefaultProps(props[propName], defaultProps[propName]);
        }
    }
    return newProps;
};
export default mergeDefaultProps;
